import { useState, useEffect } from 'react';

interface UseFormatDocumentsResult {
  formattedCpf?: string;
  formattedCnpj?: string;
}

/**
 * Hook para formatar CPF e CNPJ.
 * 
 * @param {string} cpf
 * @param {string} cnpj
 * 
 * @returns {UseFormatDocumentsResult}
 */
const useFormatDocuments = (cpf?: string | undefined, cnpj?: string | undefined): UseFormatDocumentsResult => {
  const [formattedCpf, setFormattedCpf] = useState<string | undefined>('');
  const [formattedCnpj, setFormattedCnpj] = useState<string | undefined>('');

  useEffect(() => {
    const formatCpf = (cpf: string): string => {
      return cpf.replace(
        /(\d{3})(\d{3})(\d{3})(\d{2})/,
        '$1.$2.$3-$4'
      );
    };

    const formatCnpj = (cnpj: string): string => {
      return cnpj.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        '$1.$2.$3/$4-$5'
      );
    };

    if (cpf) setFormattedCpf(formatCpf(cpf));
    if (cnpj) setFormattedCnpj(formatCnpj(cnpj));
  }, [cpf, cnpj]);

  return { formattedCpf, formattedCnpj };
};

export default useFormatDocuments;
